import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const db = getFirestore();

export const extractAuthors = (citation) => {
    if (!citation) return "—";
    const stopIndex = citation.indexOf(", '");
    if (stopIndex !== -1) {
      return citation.slice(0, stopIndex).trim();
    }
    return citation; // fallback to full string if no `'` found
  };

export const showTemporaryMessage = (message) => {
    const tempAlert = document.createElement("div");
    tempAlert.innerText = message;
    tempAlert.style.position = "fixed";
    tempAlert.style.bottom = "20px";
    tempAlert.style.right = "20px";
    tempAlert.style.backgroundColor = "#333";
    tempAlert.style.color = "white";
    tempAlert.style.padding = "10px 20px";
    tempAlert.style.borderRadius = "5px";
    tempAlert.style.zIndex = "1000";
    tempAlert.style.opacity = "0.9";
    document.body.appendChild(tempAlert);
  
    // Remove after 3 seconds
    setTimeout(() => {
      document.body.removeChild(tempAlert);
    }, 3000);
  };

  
export const isProjectUnder90Days = async (projectId) => {
  const auth = getAuth();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    console.warn("No authenticated user found.");
    return false;
  }

  const userId = currentUser.uid;
  const projectRef = doc(db, "prowa", userId, "projects", projectId);
  const projectSnap = await getDoc(projectRef);

  if (!projectSnap.exists()) return false;

  const data = projectSnap.data();
  const createdAtStr = data.created_at;

  if (!createdAtStr) return false;

  const createdAt = new Date(createdAtStr); // Parse ISO 8601 string
  const now = new Date();

  const diffDays = (now - createdAt) / (1000 * 60 * 60 * 24);
  return diffDays < 90;
};
